import { getEntityRef, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import CourseList from "./CourseList/container";
import TopBar from "./TopBar/container";

export type MapProps = RootContainerProps & {
  hasCourses: boolean;

  showPurchased: boolean;
  showUnpurchased: boolean;
};

export interface ActionProps {}

export default (props: ActionProps & MapProps) => (
  <div>
    <TopBar {...getEntityRef(props)} />

    {props.showPurchased && <CourseList {...getRootContainerProps(props)} isEnrolled={true} />}
    {props.showUnpurchased && <CourseList {...getRootContainerProps(props)} isEnrolled={false} />}
  </div>
);
